import { NavLink } from "react-router-dom"
export const EventBar = ({ categories }: any) => {
    return (<nav className="flex w-full  justify-around">
        {categories.map((category: any, index: any) => {
            return (<NavLink to={`${category}`} key={index} className={`bar no-underline hover:cursor-pointer  rounded-xl hover:animate-pulse  p-2 text-goround`
            }> {category}</NavLink>)
        })}
    </nav >)
}